export default {
  allExtra: [],
};
